import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useUserStore from "../../../utils/storeApp";

const ReportsDropdown = () => {
  const { SetSharedObject } = useUserStore((state) => ({
    SetSharedObject: state.SetSharedObject,
  }));

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    SetSharedObject("userDeleteActivity", []);
  }, [SetSharedObject]);

  const handleLinkClick = () => {
    SetSharedObject("UserActiviySearch", {});
    setIsOpen(false);
  };

  return (
    <div className="ReportsDropdown spacer-inline spacer-margin6">
      <ul className="navbar-nav flex-grow" role="menubar" aria-label="User reports navigation">
        <li className="dropdown" role="none">
          <button
            className="form-control ht-5 dropdown-toggle"
            id="reportsDropdownBtn"
            type="button"
            role="menuitem"
            aria-haspopup="menu"
            data-toggle="dropdown"
            aria-expanded={isOpen}
            aria-controls="reportsDropdownMenu"
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <span className="admin-nav2">User Reports</span>
          </button>
          <div
            className="dropdown-menu  shade-1"
            id="reportsDropdownMenu"
            role="menu"
            aria-labelledby="reportsDropdownBtn"
          >
            <Link
              to={"/user-activity"}
              className="dropdown-item"
              role="menuitem"
              onClick={handleLinkClick}
            >
              User Activity
            </Link>
            <Link
              to={"/delete-user-activity"}
              className="dropdown-item"
              role="menuitem"
              onClick={handleLinkClick}
            >
              Delete Activity
            </Link>
            <Link
              to={"/mailbox-size"}
              className="dropdown-item"
              role="menuitem"
              onClick={handleLinkClick}
            >
              Mailbox Size
            </Link>
            <Link
              to={"/user-status"}
              className="dropdown-item"
              role="menuitem"
              onClick={handleLinkClick}
            >
              User Status
            </Link>
            <Link
              to={"/message-forwarding"}
              className="dropdown-item"
              role="menuitem"
              onClick={handleLinkClick}
            >
              Message Forwarding
            </Link>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default ReportsDropdown;
